/* @flow */
import React from 'react';

import Message from 'entities/Message';
import RoleBasedMessagingComposer from 'chat/components/RoleBasedMessagingComposer.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';

class EditScheduledMessageComposer extends React.Component {
  props: {
    message: Message,
    onRequestHide: () => void,
  };

  render() {
    return (
      <Dialog
        eventScreenName="EditScheduledMessageComposer"
        size="large"
        onRequestHide={this.props.onRequestHide}>
        <div className="GroupScheduledMessage-composer-dialog">
          <RoleBasedMessagingComposer
            initialMessage={this.props.message}
            onRequestHide={this.props.onRequestHide}
            onMessageSent={this.props.onRequestHide}
            charLimit={CurrentUser.getUser().getAnnouncementCharactersLimit()}
            charLimitWithFiles={
              CurrentUser.getUser().getAnnouncementCharactersLimitWithFiles()
            }
            isEdit
          />
        </div>
      </Dialog>
    );
  }
}

export default EditScheduledMessageComposer;



// WEBPACK FOOTER //
// ./src/chat/components/EditScheduledMessageComposer.jsx